<template>
  <div>
    <div class="row center-block">
      <div class="col-md-12">
        <div class="box box-info">
          <form @submit.prevent class="form-horizontal">
            <div class="box-body">
              <div class="row">
                <div class="col-md-2">
                  <div class="q_avatar" @mouseover="showImageControl(true)" @mouseleave="showImageControl(false)">
                    <img :src="formData.imageUrl == '' ? (formData.picture ? formData.picture : '/static/img/placeholder.png') : '/image/Account/' + formData.imageUrl + '?' + Date.now()" class="img img-responsive" border="1" ref="accountImage">
                    <div class="q_form_image_controls" ref="imageControl">
                      <span class="icon ion-pencil pull-left q_select_file_button" title="Edit" @click="$refs.filePicture.click()"></span>
                      <span class="icon ion-ios-trash-o pull-right q_clear_file_button" title="Clear" @click="clearPicture()"></span>               
                      <div class="q_hidden_input_file ">
                        <input type="file" accept="image/*" ref="filePicture" @change="pictureChange">
                      </div>
                    </div>
                  </div>
                </div>
                <div class="col-md-8">                    
                  <div class="form-group">
                    <label for="inputEmail">Email Address</label>
                    <h1 style="margin-top:0px;">
                      <input type="text" :disabled="viewMode == MODE_VIEW" class="form-control" id="inputEmail" placeholder="Email Address" v-model="formData.emailAddress">                      
                    </h1>                        
                  </div>                                          
                </div>                    
              </div>
              <div class="row">
                <div class="col-md-12">
                  <div class="nav-tabs-custom">
                    <ul class="nav nav-tabs">
                      <li v-bind:class="{ active: tabActive == TAB_GENERAL }"><a href="#tab_1" data-toggle="tab" aria-expanded="true">General Info</a></li>
                      <li v-bind:class="{ active: tabActive == TAB_AUTH_PROFILE }"><a @click="onTabAuthProfile()" href="#tab_2" data-toggle="tab" aria-expanded="true">Authorization Profile</a></li>
                      <li v-bind:class="{ active: tabActive == TAB_ROLE }"><a @click="onTabRole()" href="#tab_3" data-toggle="tab" aria-expanded="true">Role</a></li>
                    </ul>
                  </div>
                  <div class="tab-content">
                    <div v-bind:class="{ active: tabActive == TAB_GENERAL }" class="tab-pane" id="tab_1">
                      <div class="box no-border">
                        <div class="row">
                          <div class="col-md-6">
                            <div class="form-group">
                              <label for="inputName" class="col-sm-4 control-label">Name</label>
                              <div class="col-sm-8">
                                <input type="text" :disabled="viewMode == MODE_VIEW" class="form-control" id="inputName" placeholder="Name" v-model="formData.name">
                              </div>
                            </div>                                         
                          </div>
                          <div class="col-md-6">
                            <div class="form-group">
                              <label for="inputHP" class="col-sm-4 control-label">HP No.</label>
                              <div class="col-sm-8">
                                <input type="text" class="form-control" id="inputHP" placeholder="" v-model="formData.handPhoneNo" :disabled="viewMode == MODE_VIEW">
                              </div>
                            </div>                            
                          </div>
                        </div>
                        <div class="row">
                          <div class="col-md-6">
                            <div class="form-group">
                              <label for="inputLastLogin" class="col-sm-4 control-label">Last Login</label>
                              <div class="col-sm-8">
                                <input type="text" class="form-control" id="inputLastLogin" placeholder="" v-model="formData.lastLogin" disabled>
                              </div>
                            </div>                                                                      
                          </div>
                          <div class="col-md-6">
                            <div class="form-group">
                              <label for="inputHP" class="col-sm-4 control-label">Password</label>
                              <div class="col-sm-8">
                                <input type="text" class="form-control" id="inputPassword" placeholder="" v-model="formData.password" :disabled="viewMode != MODE_CREATE">
                              </div>
                            </div>
                          </div>
                        </div>                          
                      </div>
                    </div>
                    <div v-bind:class="{ active: tabActive == TAB_ROLE }" class="tab-pane" id="tab_2">
                      <div class="box no-border">
                        <div class="row">
                          <div class="col-md-12">
                            <div class="form-group">
                              <div class="col-md-3 pull-right">
                                <input type="text" :disabled="viewMode == MODE_VIEW" class="form-control" id="inputName" v-model="authProfileName">
                              </div>
                            </div>                                         
                          </div>
                        </div>
                        <div class="box-body no-padding table-responsive">
                          <table class="table table-striped">
                            <thead>
                              <tr>
                                <th style="width:20px;text-align:right">#</th>
                                <th style="text-align:left;">Auth Object</th>
                                <th style="text-align:left;">Auth Field</th>
                                <th style="text-align:left;">Value</th>
                              </tr>
                            </thead>
                            <tbody>
                              <tr v-for="(row, i) in listAuthProfile" v-bind:key="i">
                                <td class="text-nowrap" style="width:20px;text-align:right;">{{ startSeqAuthProfile + i + 1}}</td>
                                <td class="text-nowrap" style="text-align:left;">{{ row.authObjectName }}</td>
                                <td class="text-nowrap" style="text-align:left;">{{ row.authFieldName }}</td>
                                <td class="text-nowrap" style="text-align:left;">{{ row.value }}</td>                                             
                                <td hidden>{{ row.id }}</td>
                                <td hidden>{{ row.authObjectId }}</td>
                                <td hidden>{{ row.authFieldId }}</td>
                                <td hidden>{{ row.authProfileId }}</td>
                              </tr>
                            </tbody>
                          </table>
                        </div>                                                
                      </div>
                    </div>                                           
                    <div v-bind:class="{ active: tabActive == TAB_ROLE }" class="tab-pane" id="tab_3">
                      <div class="box no-border">
                        <div class="box-body no-padding">
                          <div class="form-group">
                            <div class="col-sm-5">
                              <select v-model="roleIdSelected" class="form-control" :disabled="viewMode === MODE_VIEW">
                                <option v-for="(row, i) in listRole" v-bind:key="i" v-bind:value="row.id">
                                  {{ row.name }}
                                </option>
                              </select>
                            </div>
                            <div class="col-sm-1 no-padding">
                              <button style="height:32px;width:100%;" class="btn btn-primary" @click="onAddRole()" v-if="viewMode != MODE_VIEW">Add</button>
                            </div>
                            <div class="col-sm-2">
                              <button style="height:32px;width:100%;" class="btn btn-primary" @click="onGenerateAuthProfile()" v-if="viewMode != MODE_VIEW">Generate Auth Profile</button>
                            </div>                            
                          </div>
                        </div>
                        <div class="box-body no-padding table-responsive">
                          <table class="table table-striped">
                            <thead>
                              <tr>
                                <th style="width:20px;text-align:right">#</th>
                                <th style="width:40px;text-align:center;">Action</th>
                                <th style="text-align:left;">Role</th>                    
                              </tr>
                            </thead>
                            <tbody>
                              <tr v-for="(row, i) in listUserRole" v-bind:key="i">
                                <td class="text-nowrap" style="width:20px;text-align:right;">{{ startSeqUserRole + i + 1}}</td>
                                <td class="text-nowrap" style="width:40px;text-align:center;">
                                  <!-- <a href="#" v-on:click="onDisplayRoleAuthObjectField(row)" style="padding-right:5px">
                                    <span class="icon ion-search" data-toggle="tooltip" data-placement="right" title="Display"></span>
                                  </a>
                                  <a href="#" v-on:click="onEditRoleAuthObjectField(row)" style="padding-right:5px" v-if="viewMode != MODE_VIEW">
                                    <span class="icon ion-edit" data-toggle="tooltip" data-placement="right" title="Edit"></span>
                                  </a> -->
                                  <a href="#" v-on:click="onDeleteRole(row)" style="padding-right:5px" v-if="viewMode != MODE_VIEW">
                                    <span class="icon ion-ios-trash" data-toggle="tooltip" data-placement="right" title="Delete"></span>
                                  </a>                                                                               
                                </td>
                                <td class="text-nowrap" style="text-align:left;">{{ row.name }}</td>                                              
                                <td hidden>{{ row.id }}</td>
                                <!-- <td hidden>{{ row.authObjectId }}</td>
                                <td hidden>{{ row.authFieldId }}</td> -->
                              </tr>
                            </tbody>
                          </table>
                        </div>                                                
                      </div>
                    </div>
                  </div>
                </div>
              </div>                                                                     
              <input type="hidden" class="form-control" id="inputId" v-model="formData.id">
            </div>

            <div class="box-footer">
              <div class="box-tools">
                <button @click="onBack()" class="btn btn-default" style="margin-right:15px;">Back</button>
                <button v-if="viewMode != MODE_VIEW" @click="onCancel()" class="btn btn-warning">Cancel</button>
                <button v-if="viewMode != MODE_VIEW" @click="onSave()" class="btn btn-info pull-right">Save</button>
                <button v-if="viewMode == MODE_VIEW" @click="onEdit(formData)" class="btn btn-info pull-right">Edit</button>
                <button v-if="viewMode == MODE_VIEW" @click="onCreate()" class="btn btn-info pull-right" style="margin-right:15px;">Create</button>
              </div>
            </div>

          </form>
        </div>          
      </div>
    </div> 
  </div>  
</template>

<script>
import api from '../../api'
import SweetAlert from 'sweetalert2'
import datepicker from '../../components/widgets/DatePicker'
import config from '../../config'
import utilities from '../../utilities'

const MODE_NONE = 'none'
const MODE_CREATE = 'create'
const MODE_VIEW = 'read'
const MODE_UPDATE = 'update'
const TAB_GENERAL = 'tabGeneral'
const TAB_AUTH_PROFILE = 'tabAuthProfile'
const TAB_ROLE = 'tabRole'

export default {
  name: 'UserForm',
  components: {
    datepicker
  },
  data() {
    return {
      DATE_FORMAT: config.dateFormat,
      MODE_NONE: MODE_NONE,
      MODE_CREATE: MODE_CREATE,
      MODE_VIEW: MODE_VIEW,
      MODE_UPDATE: MODE_UPDATE,
      TAB_GENERAL: TAB_GENERAL,
      TAB_AUTH_PROFILE: TAB_AUTH_PROFILE,
      TAB_ROLE: TAB_ROLE,
      formData: {
        id: 0,
        name: '',
        emailAddress: '',
        handPhoneNo: 0,
        password: '',
        passwordSalt: '',
        jwtKey: '',
        lastLogin: '',
        imageUrl: '',
        picture: null
      },
      tabActive: '',
      listCompany: null,
      listRole: null,
      listUserRole: undefined,
      roleIdSelected: 0,
      startSeqUserRole: 0,
      authProfileId: 0,
      authProfileName: '',
      listAuthProfile: null,
      startSeqAuthProfile: 0
    }
  },
  computed: {
  },
  created() {
    this.formData.id = this.$route.params.callbackId ? this.$route.params.callbackId : this.$route.params.id
    this.viewMode = this.$route.params.mode
    this.callback = this.$route.params.callback

    this.tabActive = TAB_GENERAL
    this.getDetail()
  },
  mounted() {
  },
  methods: {
    toDataURL(url, callback) {
      var xhr = new XMLHttpRequest()
      xhr.onload = function() {
        var reader = new FileReader()
        reader.onloadend = function() {
          callback(reader.result)
        }
        reader.readAsDataURL(xhr.response)
      }
      xhr.open('GET', url)
      xhr.responseType = 'blob'
      xhr.send()
    },
    getDetail() {
      var me = this
      if (this.formData.id !== 0) {
        api
          .request('Account', 'get', '/api/Account/GetDetail?Id=' + this.formData.id, null)
          .then(response => {
            var data = response.data
            this.formData = data.entity
          })
          .then(response => {
            this.toDataURL(me.$refs.accountImage.src, function(dataUrl) {
              me.formData.picture = dataUrl
              me.formData.imageUrl = ''
            })
          })
          .catch(error => {
            var message = error.message + ':<br>' + error.response.data.returnMessage.join('<br>')
            SweetAlert.fire('Error', message, 'error')
          })
      }
    },
    showImageControl(show) {
      if (this.viewMode === MODE_VIEW) {
        return
      }
      let el = this.$refs.imageControl
      el.style.opacity = show ? 0.8 : 0
    },
    pictureChange(e) {
      const image = e.target.files[0]
      const reader = new FileReader()
      reader.readAsDataURL(image)
      reader.onload = e => {
        this.formData.picture = e.target.result
        this.$refs.accountImage.src = e.target.result
      }
    },
    clearPicture() {
      this.formData.picture = null
      this.formData.imageUrl = ''
    },
    initForm() {
      this.formData.id = 0
      this.formData.name = ''
      this.formData.companyId = 0
      this.formData.companyName = ''
      this.formData.imageUrl = ''
      this.formData.picture = null
      this.formData.password = ''
    },
    onDisplay() {
      this.viewMode = MODE_VIEW
      this.getDetail()
    },
    onEdit(formData) {
      if (!utilities.IsObjectAuthorized('Users', 'Activity', 'Edit')) {
        return
      }
      this.viewMode = MODE_UPDATE
      this.getDetail()
    },
    onCancel() {
      this.initForm()
    },
    onBack() {
      this.$router.push({ name: this.callback })
    },
    onSave() {
      var reqData = null

      var status = 'success'
      var message = ''
      var method = ''
      switch (this.viewMode) {
        case MODE_CREATE:
          method = 'Register'
          reqData = {
            Id: this.formData.id,
            EmailAddress: this.formData.emailAddress,
            Name: this.formData.name,
            HandPhoneNo: this.formData.handPhoneNo,
            LastLogin: this.formData.lastLogin,
            ImageBase64String: this.formData.picture,
            Password: this.formData.password
          }
          break
        case MODE_UPDATE:
          method = 'Update'
          reqData = {
            Id: this.formData.id,
            EmailAddress: this.formData.emailAddress,
            Name: this.formData.name,
            HandPhoneNo: this.formData.handPhoneNo,
            LastLogin: this.formData.lastLogin,
            ImageBase64String: this.formData.picture
          }
          break
      }

      api
        .request('Account', 'post', '/api/Account/' + method, reqData)
        .then(response => {
          var resData = response.data
          this.formData = resData.entity

          if (resData.returnStatus) {
            this.onDisplay({id: this.formData.id, name: this.formData.name})
          }

          status = resData.returnStatus ? 'success' : 'error'
          message = resData.returnMessage.join('<br>')
          SweetAlert.fire(status, message, status)
        })
        .catch(error => {
          var message = error.message + ':<br>' + error.response.data.returnMessage.join('<br>')
          SweetAlert.fire('Error', message, 'error')
        })
    },
    onTabAuthProfile() {
      api
        .request('Account', 'get', '/api/Role/InquiryUserAuthProfile?UserId=' + this.formData.id, null)
        .then(response => {
          var resData = response.data

          if (resData.entity) {
            this.authProfileId = resData.entity.id
            this.authProfileName = resData.entity.name

            api
              .request('Account', 'get', '/api/Role/InquiryAuthProfileDetail?Id=' + this.authProfileId, null)
              .then(response => {
                var resData = response.data
                this.listAuthProfile = resData.entity
              })
              .catch(error => {
                var message = error.message + ':<br>' + error.response.data.returnMessage.join('<br>')
                SweetAlert.fire('Error', message, 'error')
              })
          }
        })
        .catch(error => {
          var message = error.message + ':<br>' + error.response.data.returnMessage.join('<br>')
          SweetAlert.fire('Error', message, 'error')
        })
    },
    onTabRole() {
      api
        .request('Account', 'get', '/api/Role/InquiryAll', null)
        .then(response => {
          var resData = response.data
          this.listRole = resData.entity

          // status = resData.returnStatus ? 'success' : 'error'
          // message = resData.returnMessage.join('<br>')
          // SweetAlert.fire(status, message, status)
        })
        .catch(error => {
          var message = error.message + ':<br>' + error.response.data.returnMessage.join('<br>')
          SweetAlert.fire('Error', message, 'error')
        })

      api
        .request('Account', 'get', '/api/Role/InquiryUserAuthProfile?UserId=' + this.formData.id, null)
        .then(response => {
          var resData = response.data

          if (resData.entity) {
            this.authProfileId = resData.entity.id
            this.authProfileName = resData.entity.name

            api
              .request('Account', 'get', '/api/Role/InquiryAuthProfileRole?Id=' + this.authProfileId, null)
              .then(response => {
                var resData = response.data
                this.listUserRole = resData.entity
              })
              .catch(error => {
                var message = error.message + ':<br>' + error.response.data.returnMessage.join('<br>')
                SweetAlert.fire('Error', message, 'error')
              })
          }
        })
        .catch(error => {
          var message = error.message + ':<br>' + error.response.data.returnMessage.join('<br>')
          SweetAlert.fire('Error', message, 'error')
        })
    },
    onAddRole() {
      if (this.listUserRole) {
        this.listUserRole.push(this.listRole.find(x => x.id === this.roleIdSelected))
      } else {
        this.listUserRole = []
        this.listUserRole.push(this.listRole.find(x => x.id === this.roleIdSelected))
      }
    },
    onDeleteRole(row) {
      let item = this.listUserRole.find(x => x.id === row.id)
      let idx = this.listUserRole.indexOf(item)
      if (idx > -1) {
        this.listUserRole.splice(idx, 1)
      }
    },
    onGenerateAuthProfile() {
      let status = false
      let message = ''
      api
        .request('Account', 'post', '/api/Role/GenerateAuthProfile?UserId=' + this.formData.id, this.listUserRole)
        .then(response => {
          var resData = response.data
          status = resData.returnStatus ? 'success' : 'error'
          message = resData.returnMessage.join('<br>')
          SweetAlert.fire(status, message, status)
        })
        .catch(error => {
          var message = error.message + ':<br>' + error.response.data.returnMessage.join('<br>')
          SweetAlert.fire('Error', message, 'error')
        })
    }
  }
}
</script>

<style scoped>
.fade-enter-active, .fade-leave-active {
  transition: opacity .5s;
}
.fade-enter, .fade-leave-to /* .fade-leave-active below version 2.1.8 */ {
  opacity: 0;
}
input[type=text], select {
  font-family: inherit;
  font-size: inherit;
  line-height: inherit;
  border: 1px solid #ccc;
  border-top-style: none;
  border-right-style: none;
  border-left-style: none;
  color: #777;
  margin: 0px;
}
input:focus {
  outline: none;
  border-bottom: 2px solid #337AB7;
}

.q_avatar {
  float: left;
  box-sizing: border-box;
  position: relative;
  text-align: inherit;
}
.q_avatar > img {
  max-height: 90px;
  max-width: 90px;
  margin-bottom: 10px;
  box-shadow: 0 1px 4px rgba(0, 0, 0, 0.4);
  border: none;
}
.q_form_image_controls {
  position: absolute;
  top: 0;
  left: auto;
  bottom: auto;
  right: 0;
  width: 100%;
  color: white;
  background-color: #337AB7;
  opacity: 0;
  transition: opacity ease 400ms;
}
.q_hidden_input_file {
  position: absolute;
  top: 1px;
  opacity: 0;
  width: 100%;
  height: 26px;  
  display: none;
}
.q_form_image_controls > .ion {
  margin: 5px;
  cursor: pointer;
}
</style>



// WEBPACK FOOTER //
// UserForm.vue?614f1a76